<div class="editable-container d-block w-100">
	<ng-content></ng-content>

	<button class="btn btn-circle btn-sm edit-button {{ isEditing ? 'btn-dark' : 'btn-secondary' }}" [disabled]="!isEditable" (click)="edit()">
		<i class="fa-sharp fa-regular fa-pen"></i>
	</button>
</div>